import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import BackArrow from 'src/atoms/backArrow/backArrow'
import Button from 'src/atoms/dropdown/dropdown'
import FloatingInput from 'src/atoms/floatingInput/floatingInput'
import FloatingSelect from 'src/atoms/floatingSelect/floatingSelect'
import GenericModal from 'src/GenericModal'
import "./OfflinePayment.scss"
import { Info_Yellow } from "../../assets/images/assetsAll"
import PlusIcon from "../../assets/images/plusIcon.svg"
import { formatAmountinINR, getCookie } from 'src/utils/utils'
import { makeAPICall } from 'src/services/apiService'
import CheckTick from "../../assets/images/checked-tick.svg"
import PageLoader from 'src/atoms/pageLoader'
import checked from "../../assets/logoImg/checked.svg"
import warnRed from "../../assets/images/warn-red.svg"
import greyCheck from "../../assets/images/greyCheck.svg"
import orangeTarget from "../../assets/images/orangeTarget.svg"
import { BottomSheetWithBtn } from '../BottomSheetWithBtn'

function OfflinePayment() {
  const cash="CASH",demand_draft="DEMAND_DRAFT",cheque="CHEQUE"
  const history = useHistory()
  const [loading, setLoading] = useState(false);
  const offlineTypes = ["CASH", "CHEQUE", "DEMAND_DRAFT", "NEFT", "RTGS","IMPS","POS_MACHINE"]
  const [userDetails, SetUserDetails] = useState({ payment_method:"CHEQUE"})
  console.log('userDetails:', userDetails)
  const [currentOfflineType, setCurrentOfflineType] = useState(userDetails?.payment_method)
  console.log('currentOfflineType:', currentOfflineType)
  const [uploadedFile, setUploadedFile] = useState([])
  const [offlineAmount, setOfflineAmount] = useState(userDetails?.amount)
  const [paymentType, SetPaymentType] = useState("BALANCE_PAYMENT")
  const [paymentMethodText, setPaymentMethodText] = useState()
  console.log('offlineAmount:', offlineAmount)
  const [micrNumber, setMicrNumber] = useState(null)
  console.log('micrNumber:', micrNumber)
  const [btnDisableStatus, setBtnDisableStatus] = useState(true)
  const imgArr = [1,2,3,4]
  const [imgList, setImgList] = useState({})
  const [splitPayments, setSplitPayments] = useState([])
  const [instrumentCalled, setInstrumentCalled] = useState(false)
  const [totalPayable, setTotalPayable] = useState('')
  const { search } = useLocation();
  const [ bottomSheetError,setBottomSheetError] = useState('');
  let isSplitPayment = new URLSearchParams(search).get("isSplitPayment")
  let isOlaCareEwPayment = new URLSearchParams(search).get("olaCareEwPayment")
  

  //toast states
  const [showToggle, setShowToggle] = useState(false)
  const [toastMsg, setToastMsg] = useState("")

  //pop up states
  const [showOfflineType, setOfflineType] = useState(false)
  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const [canceledByCustomer,setCanceledByCustomer]=useState(false)

  // user info has orderId name and customer id
  const userInfo = JSON.parse(sessionStorage.getItem("user_details"))


  useEffect(() => {
    console.log(userDetails,uploadedFile,  "===userDetails>>");
    let btnStatus = checkBtnStatus()
    if ((userDetails?.status == "INITIATED" || userDetails?.status == "SUCCESS") && !["SPLIT_PAYMENT", "BALANCE_PAYMENT"].includes(paymentType)) {
      setBtnDisableStatus(true)
    }
    else {
      setBtnDisableStatus(btnStatus)
    }
  }, [userDetails, uploadedFile])

  
  

  useEffect( () => {
    //get previous user details
    callingApis()
  }, [])
  
  async function callingApis() {
   await getUserDetails()
    getOfflinePaymentAmount()
    getOfflineSplits()
  }
  useEffect(() => {
    // set image if available and option selected is not cash
    if (uploadedFile?.length) {
      uploadedFile.forEach((item, i) => {
        console.log(item, "====")
        if(!item?.file) return
        const header = item.file.split(",")[0]
        const fileType = header.split(";")[0].split("/")[1];
        console.log(fileType, "fileTypeasdf", header);
        if (fileType?.toLowerCase() === "pdf" || fileType?.toLowerCase() === "heic" || fileType?.toLowerCase() === "heif") {
          imgList[`preview-img-${i+1}`] = item.file
          document.getElementById('preview-img-' + (i+1)).src = CheckTick
          document.getElementById('preview-img-' + (i+1)).style.width = "20%"
          document.getElementById('preview-img-' + (i+1)).style.left = "38%"
        }
        else {
          imgList[`preview-img-${i+1}`] = item.file
          document.getElementById('preview-img-' + (i+1)).src = item.file
          document.getElementById('preview-img-' + (i+1)).style.width = "100%"
          document.getElementById('preview-img-' + (i+1)).style.left = "0"
        }
        setImgList({...imgList})
      })
    }
  }, [userDetails?.payment_method, uploadedFile])
  
  useEffect(() => {
    // get amount from user on every payment type change
      // getOfflinePaymentAmount()
  }, [])

  useEffect(() => {
    // set the label of floating input text based on selected drop down
    if (currentOfflineType === "CHEQUE") {
      setPaymentMethodText("Cheque number")
    }
    else if (currentOfflineType === "POS_MACHINE") {
      setPaymentMethodText("Transaction Reference Number")
    }
    else if (currentOfflineType === "DEMAND_DRAFT") {
      console.log("dd");
      setPaymentMethodText("Demand draft number")
    }
    else if (currentOfflineType === "NEFT" || currentOfflineType === "RTGS" || currentOfflineType === "IMPS") {
      setPaymentMethodText("UTR number")
    }
  }, [currentOfflineType])

  const toggleToaster = (msg, time = 2000) => {
    setShowToggle(true)
    setToastMsg(msg)
    setTimeout(() => {
      setShowToggle(false)
      setToastMsg("")
    }, time)
  }

  function checkBtnStatus() {
    // logic for enabling and disabling button
    console.log(userDetails, uploadedFile,"==btn stastus check");
    if (userDetails?.payment_method === "CHEQUE" || userDetails?.payment_method === "DEMAND_DRAFT") {
      if (userDetails?.amount && (userDetails?.micr?.length === 9) && (userDetails?.instrument_id?.length === 6 ) && uploadedFile?.length > 0) {
        return false
      }
      else {
        return true
      }
    }
    else if (userDetails?.payment_method === "CASH") {
      //api false , return true
      console.log("userDetails for cash : ",userDetails);
      if (userDetails?.amount) {
        let enable_cash_payment_without_docs = userDetails?.enable_cash_payment_without_docs;
        if(userDetails?.documents?.length > 0 || enable_cash_payment_without_docs == null){
          return false;
        }
        else {
        return !enable_cash_payment_without_docs;
        }
        return false
      }
      else {
        return true
      }

    }
    else if (userDetails?.payment_method === "NEFT") {
      if (userDetails?.amount && userDetails?.instrument_id?.length >= 16 && userDetails?.instrument_id?.length <= 22 && uploadedFile?.length > 0) {
        return false
      }
      else {
        return true
      }
    } else if (userDetails?.payment_method === "POS_MACHINE") {
      if (userDetails?.amount && userDetails?.instrument_id?.length >= 10 && userDetails?.instrument_id?.length <= 10 && uploadedFile?.length > 0) {
        return false
      }
      else {
        return true
      }
    }  else if(userDetails?.payment_method==="RTGS"){
      if(userDetails?.amount && userDetails?.instrument_id?.length >= 16 && userDetails?.instrument_id?.length <= 22 && uploadedFile?.length > 0){
        return false
      }
      else{
        return true
      }
    }
    else if (userDetails?.payment_method === "IMPS") {
      if (userDetails?.amount && userDetails?.instrument_id?.length === 12 && uploadedFile?.length > 0) {
        return false
      }
      else {
        return true
      }
    }
  }
  function checkBtnStatusWithoutDoc() {
    if (userDetails?.payment_method === "CHEQUE" || userDetails?.payment_method === "DEMAND_DRAFT") {
      if (userDetails?.amount && (userDetails?.micr?.length === 9) && (userDetails?.instrument_id?.length === 6 )) {
        return false
      }
      else {
        return true
      }
    }
    else if (userDetails?.payment_method === "CASH") {
      if (userDetails?.amount ) {
        return false
      }
      else {
        return true
      }

    }
    else if (userDetails?.payment_method === "NEFT") {
      if (userDetails?.amount && userDetails?.instrument_id?.length >= 16 && userDetails?.instrument_id?.length <= 22) {
        return false
      }
      else {
        return true
      }
    } else if(userDetails?.payment_method==="RTGS"){
      if(userDetails?.amount && userDetails?.instrument_id?.length >= 16 && userDetails?.instrument_id?.length <= 22){
        return false
      }
      else{
        return true
      }
    }
    else if (userDetails?.payment_method === "IMPS") {
      if (userDetails?.amount && userDetails?.instrument_id?.length === 12) {
        return false
      }
      else {
        return true
      }
    }
  }

  async function getUserDetails() {
    // api call for getting user previous details
    setLoading(true)
    let getuserPreviousDetails = {
      method: 'get',
      url: 'api/offlinePayment/getOfflinepaymentDetails',
      params: {
        orderId: userInfo?.order_id,
        customer_uuid: userInfo?.customer_id
      }
    }
    await makeAPICall(getuserPreviousDetails)
      .then((resp) => {
        console.log(resp?.data, "previous user details");
        if (resp?.data?.payment_method) { 
          setCurrentOfflineType(resp?.data?.payment_method)
        }
        if(!(isSplitPayment == "true" || isOlaCareEwPayment == "true")) {
          setUploadedFile(resp?.data?.documents || [])
          // document.getElementById('preview-img').src = resp?.data?.documents?.[0]?.data?.dummyFile?.file
          SetUserDetails((prev) => { return { ...prev, ...resp?.data } })
        } else {
          setUploadedFile([])
        }
        setLoading(false)
      })
      .catch((err) => {
        toggleToaster("Cannot find user details")
        console.log("error in getting user previous data", err);
        setLoading(false)
      })
  }

  const getOfflineSplits = async () => {
    let offlineSplitsPayload = {
      method: 'get',
      url: 'api/offlinePayment/getOfflineSplits',
      params: {
        orderId: userInfo?.order_id,
        customer_uuid: userInfo?.customer_id
      }
    }
    await makeAPICall(offlineSplitsPayload)
      .then((resp) => {
        if(resp.data?.all_payment_transactions.some(a => a.payment_type == "SPLIT_PAYMENT")) {
          setSplitPayments(resp.data?.all_payment_transactions.sort((a,b) => b.created - a.created)?.reverse() || [])
        } else {
          setSplitPayments([])
        }
      })
      .catch((err) => {
        console.log("error in getting offlineSplits Payload", err);
      })
  }

  const isDisabled = () => {
    if (!uploadedFile?.length) {
      return false;
    }
    return true;
  };

  function getOfflinePaymentAmount(el) {
    // api call for getting user amount
    setLoading(true)
    let getOfflinePaymentAmount = {
      method: 'get',
      url: 'api/offlinePayment/getOfflinePaymentAmount',
      params: {
        orderId: userInfo?.order_id,
        customer_uuid: userInfo?.customer_id
      }
    }
      makeAPICall(getOfflinePaymentAmount)
      .then((response) => {
        console.log(response?.data?.data?.amount, "offline amount** ");
        //replicate
        // response.data.data.enable_cash_payment_without_docs = false;
        SetUserDetails(prev => { return { ...prev, amount: response?.data?.data?.amount,enable_cash_payment_without_docs : response?.data?.data?.enable_cash_payment_without_docs } })
        console.log(response?.data?.data?.enable_cash_payment_without_docs,"XXXXX");
        if (response?.data?.data) {
             const enable_cash_payment_without_docs =
             response?.data?.data?.enable_cash_payment_without_docs;
             localStorage.setItem("enable_cash_payment_without_docs",enable_cash_payment_without_docs);
        }
        SetUserDetails(prev => { return { ...prev, amount: response?.data?.data?.amount } })
        SetPaymentType(response?.data?.data?.payment_type)
        if(response?.data?.data?.payment_type == "SPLIT_PAYMENT") {
          setTotalPayable(response?.data?.data?.total_payable_amount)
        } else {
          setTotalPayable("")
        }
        setOfflineAmount(response?.data?.data?.amount)
        setLoading(false)
      })
        .catch((err) => {
          toggleToaster("Cannot find amount for user")
          console.log("Error in Getting offline paymnet amount", err);
          setLoading(false)
      })
    // }
    // else{
    //   // show toast message
    //   toggleToaster("Something went wrong")
    // }
  }

  const callOnceDataFilled = async () => {
    if((userDetails?.status == "INITIATED" || userDetails?.status == "SUCCESS") && !["SPLIT_PAYMENT", "BALANCE_PAYMENT"].includes(paymentType) ) {
      return
    }
    if(!checkBtnStatusWithoutDoc()) {
      let postingUserData = {
        method: 'post',
        url: `/api/offlinePayment/postOfflinepaymentDetails?customer_uuid=${userInfo?.customer_id}`,
        params: {
          customer_uuid: userInfo?.customer_id
        },
        data: {
          // amount: userDetails?.amount,
          brand_champion_id: getCookie('utm_uuid'),
          comments:"",
          order_id: userInfo?.order_id,
          payment_method: userDetails?.payment_method,
          payment_type: paymentType,
          status: "",
          user_id: JSON.parse(sessionStorage.getItem('user_details'))?.customer_id
        }
      }
      if (currentOfflineType !== "CASH") {
        if (currentOfflineType === "CHEQUE" || currentOfflineType === "DEMAND_DRAFT") {
          postingUserData.data.micr = userDetails?.micr
        }
          postingUserData.data.instrument_id = userDetails?.instrument_id;
      }
      console.log(postingUserData,"postingUserData");
      if (postingUserData) {
       await makeAPICall(postingUserData)
         .then((response) => {
            console.log(response,"response after posting user data");
            setLoading(false)
            setInstrumentCalled(true)
            // uploading photo of cheque or DD
          })
          .catch((err) => {
          console.log("Error in posting user Data", err);
          setLoading(false)
          toggleToaster("Please enter payment details")
        })
      }
    }
  }

  const onFileChange = async (evt, ind) => {
    if((userDetails?.status == "INITIATED" || userDetails?.status == "SUCCESS") && !["SPLIT_PAYMENT", "BALANCE_PAYMENT"].includes(paymentType) ) {
      return
    }
    if(!checkBtnStatusWithoutDoc()) {
      let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic|\.heif)$/i;
      const [file] = evt.target?.files;
      let extension = file?.name.substr(file?.name.lastIndexOf("."));
      let size = parseFloat(file?.size / (1024 * 1024)).toFixed(2);
      console.log('size:', size)
      if (allowedExtensions.exec(extension)) {
        console.log('90890asd:', size)
        if (size <= 7) {
          // console.log('file:', file)
          // let mimeType = file?.type;
          let reader = new FileReader();
          let base64Version = '';
          reader.readAsDataURL(file);
          reader.onload = async function () {
            base64Version = reader.result;
            // let base64ToBlob = getFileObject(base64Version, mimeType);
            // const prepend = `data:${mimeType};base64`;
            // const cleanedBase64 = base64Version.replace(`${prepend},`, '');
            if (base64Version) {
              // let tmpUpload = uploadedFile;
              // console.log(tmpUpload, uploadedFile, "tmpUpload", base64Version);
              // tmpUpload[ind] = tmpUpload[ind] ? {...tmpUpload[ind], file: base64Version} : {file: base64Version};
              // setUploadedFile(tmpUpload);
  
              saveEachDocument("OFFLINE_PAYMENT_" + ind, base64Version, ind)
              // saveEachDocument("OFFLINE_PAYMENT", base64Version, ind)
            }
          };
          if (file) {
            
            if (extension?.toLowerCase() == ".pdf" || extension?.toLowerCase() == ".heic" || extension?.toLowerCase() == ".heif") {
              document.getElementById('preview-img-' + ind).src = CheckTick
              document.getElementById('preview-img-' + ind).style.width = "20%"
              document.getElementById('preview-img-' + ind).style.left = "38%"
            }
            else {
              console.log(file,URL.createObjectURL(file),  "tmpUpload")
              document.getElementById('preview-img-' + ind).src = URL.createObjectURL(file);
              document.getElementById('preview-img-' + ind).style.width = "100%"
              document.getElementById('preview-img-' + ind).style.left = "0"
            }
          } 
        } else {
          toggleToaster("Please upload images less than 7 mb")
        }
      }
      else {
        toggleToaster("Please upload images of type(jpeg,jpg,png,heic,heif)")
      }
    } else {
      toggleToaster("Please fill all details before uploading images")
    }
}

  const saveEachDocument = (type, file, ind) => {
  let index = type.split(`OFFLINE_PAYMENT_`)[1]
  let fileBody = {
    file: file,
    type: index == 1 ? "OFFLINE_PAYMENT" : type,
    view: "FRONT",
    data: {},
    is_address_proof: false,
  }

  let uploadBody = {
    address_proof: "",
    already_uploaded: false,
    order_id: userInfo?.order_id,
    files: [fileBody],
  };
  let config = {
    method: "put",
    url: `api/offlinePayment/postOfflinepaymentDoc`,
    params: {
      ...userInfo,
      customer_uuid: userInfo?.customer_id
    },
    data: { ...uploadBody },
  };

  setLoading(true)
  
  makeAPICall(config)
    .then((resp) => {
      if (resp && resp.data?.status === "SUCCESS") {
        setLoading(false)
        document.getElementById('preview-img-' + (index)).style.border = '2px solid lawngreen';
        imgList[`preview-img-${index}`] = true
        setImgList({...imgList})
        uploadedFile[index-1] = {file : file}
        setUploadedFile([...uploadedFile]);
         //enable btn post pic upload
         console.log("Post upload userDetails : ",userDetails);
         if(userDetails?.payment_method=="CASH" && userDetails?.enable_cash_payment_without_docs == false){
         setBtnDisableStatus(false);
         }
      }
    })
    .catch((err) => {
      document.getElementById('preview-img-' + (index)).style.border = '2px solid red'
      setLoading(false)
    });
  }
  


  function handleOfflineTypeDropDownClicked(el) {
    // payment type : Cash ,Cheque , DD ,NEFT, RTGS, IMPS
    if (el == userDetails?.payment_method) {
      return
    }
    // setUploadedFile([])
    setCurrentOfflineType(el)
    SetUserDetails(prev => { return { ...prev, payment_method: el,instrument_id:""} })
    setOfflineType(false)
  }

  

  async function handleInitiatePayment() {
    setLoading(true)
    let userDetailsUploadSuccess = false;
    // 2 api call on intiate payment btn click 
    // 1 for posting user details
    // 2 for uploading doc if needed
    console.log(userInfo?.customer_id,"asdfasdfdsa");
    let postingUserData = {
      method: 'post',
      url: `/api/offlinePayment/postOfflinepaymentDetails?customer_uuid=${userInfo?.customer_id}`,
      params: {
        customer_uuid: userInfo?.customer_id
      },
      data: {
        // amount: userDetails?.amount,
        brand_champion_id: getCookie('utm_uuid'),
        comments:"",
        order_id: userInfo?.order_id,
        payment_method: userDetails?.payment_method,
        payment_type: paymentType,
        status: "",
        user_id: JSON.parse(sessionStorage.getItem('user_details'))?.customer_id
      }
      // ,
      // params: {
      //   customer_uuid: userInfo?.customer_id
      // }
    }
    console.log('currentOfflineType44:', currentOfflineType)



          if (currentOfflineType && currentOfflineType === "CASH") {
            console.log("currentOfflineType: xxxx", currentOfflineType);
          }
          else{
            localStorage.removeItem("enable_cash_payment_without_docs");
          }
      
  

    if (currentOfflineType !== "CASH") {
      if (currentOfflineType === "CHEQUE" || currentOfflineType === "DEMAND_DRAFT") {
        postingUserData.data.micr = userDetails?.micr
      }
        postingUserData.data.instrument_id = userDetails?.instrument_id;
    }
    // else if (currentOfflineType === "Demand Draft") {
    //   postingUserData.data.instrument_id = userDetails?.instrument_id
    // }
    console.log(postingUserData,"postingUserData");
    if (postingUserData) {
     await makeAPICall(postingUserData)
       .then((response) => {
          userDetailsUploadSuccess=true
          console.log(response,"response after posting user data");
          setLoading(false)
        })
        .catch((err) => {
        console.log("Error in posting user Data", err);
        setLoading(false);
      })
    }
    // if (currentOfflineType === "Cheque" || currentOfflineType === "Demand Draft") {
      
    // }
    
    if (userDetailsUploadSuccess) {
      setConfirmationPopup(true)
    }
    // if (userDetails?.payment_method === "CASH") {
    //   if (userDetailsUploadSuccess) {
    //     setConfirmationPopup(true)
    //   }
    // }
    // else if (userDetails?.payment_method === "CHEQUE" || userDetails?.payment_method === "DEMAND_DRAFT") {
    //   if (userDetailsUploadSuccess) {
    //     setConfirmationPopup(true)
    //   }
    // }
  }


  const uploadSingleFile = async (uploadedFile, ind) => {
    const header = uploadedFile.split(",")[0]
      const fileType = header.split(";")[0].split("/")[1];
      let postDocumentDetails = {
        method: "PUT",
        url: "/api/offlinePayment/postOfflinepaymentDoc",
        params: {
          customer_uuid: userInfo?.customer_id
        },
        data: {
          address_proof: "",
          already_uploaded: false,
          order_id: userInfo?.order_id,
          files: [
            {
              file: uploadedFile,
              type: "OFFLINE_PAYMENT_" + ind,
              view: "FRONT",
              data: {
                documentNumber: userDetails?.instrument_id,
                doc_ext: fileType
              },
              is_address_proof: false
            }
          ]
        }
      }
      await makeAPICall(postDocumentDetails)
        .then((response) => {
          setLoading(false)
          console.log(response, "successfully document uploaded");
        })
        .catch((err) => {
          console.log("Error in uploading Document", err);
          setLoading(false)
        })
  }

  function initiateApiCall() {
    let initiatePayment = {
      method: 'PUT',
      url: '/api/offlinePayment/initiatePayment',
      data: {
        order_id: userInfo?.order_id,
        user_id: userInfo?.customer_id,
        payment_type: paymentType
      }
    }
    makeAPICall(initiatePayment)
      .then((resp) => {
        console.log("success initiate api");
        history.push("/offlinePaymentSuccess")
        setLoading(false)
      })
      .catch((err) => {
        console.log("Error in initiate payment", err, err.response);
        setLoading(false);
        setConfirmationPopup(false);
        setBottomSheetError(err.response.data);
      })
  }

   function handleConfirmClick(e) {
    e.stopPropagation();
    e.preventDefault();
    setLoading(true)
    
    if (getCookie("offline_unique_code")) {
    let config = {
      method: "get",
      url: `api/pos/paymentStatus`,
      params: {
        unique_code: getCookie("offline_unique_code") || "",
      },
    };
    makeAPICall(config)
      .then((resp) => {
        console.log(resp?.data?.data?.status, "pos api");
        if (resp?.data?.data?.status === "CanceledByCustomer") {
          setCanceledByCustomer(true)
          setLoading(false)
          setConfirmationPopup(false)
        }
        else {
            initiateApiCall()
        }
      })
      .catch((err) => {
        toggleToaster("Something went wrong!")
        setLoading(false)
      });
    // };
    }
     else {
       initiateApiCall()
      //  setLoading(false)
      // toggleToaster("Something went wrong!")
     }

    // 
  }
  function onPaymentMethodClick() {
    if (userDetails?.status !== "INITIATED" && userDetails?.status !== "SUCCESS") {

      setOfflineType(!showOfflineType)
      setInstrumentCalled(false)
    } 
  }

  function cancelApiCall() {
    if (getCookie("offline_unique_code") && (userDetails?.status !== "SUCCESS" && userDetails?.status !== "INITIATED") ) {
      let config = {
        method: "put",
        url: `api/pos/cancelPaymentByBc?offline_payment=true`,
        data: {
          unique_code: getCookie("offline_unique_code")||"",
        },
      };

      setLoading(true)
      makeAPICall(config)
        .then((resp) => {
          if (getCookie('from_purchase_flow') == 'true')
            history.go(-3)
          else  
            history.goBack();
        })
        .catch((err) => {
          toggleToaster("Something went wrong!")
          if (getCookie('from_purchase_flow') == 'true')
            history.go(-3)
          else  
            history.goBack();
        });
      setLoading(false)
    }
    else {
      if (getCookie('from_purchase_flow') == 'true')
            history.go(-3)
          else  
            history.goBack();
    }
  }

  const getLength = () => {
    if(userDetails?.payment_method === "CHEQUE" || userDetails?.payment_method === "DEMAND_DRAFT") {
      return 6
    } else if (userDetails?.payment_method === "NEFT" || userDetails?.payment_method === "RTGS") {
      return '16 - 22'
    } else if (userDetails?.payment_method === "IMPS") {
      return 12
    }else if (userDetails?.payment_method === "POS_MACHINE") {
      return '10'
    }
  }

  const getSplitStatusImg = (split) => {
    switch(split.status) {
      case "SUCCESS":
        return checked;
      case "FAILURE":
        return warnRed;
      case "CREATED":
        return orangeTarget;
      case "APPROVED":
        return greyCheck;
      default: 
        return checked;
    }
  }

  const getSplitStatusText = (split) => {
    switch(split.status) {
      case "SUCCESS":
        return "Paid by customer";
      case "FAILURE":
        return "Rejected";
      case "CREATED":
        return "Approval pending";
      case "APPROVED":
        return "Approved";
      default: 
        return "Paid";
    }
  }
  return (
    <div className='offline-user-details-wrapper'>
      {
        loading && (
          <PageLoader/>
        )
      }
      <div className='offline-header-div'>
        <div onClick={() => { cancelApiCall()}}>
            <BackArrow removeClass={true} />
        </div>
        <div className='offline-header'>Offline payment</div>
      </div>
      <div className="offline-user-details-div">
        {splitPayments.length == 0 && userDetails?.status && <div className={`offlinepayment-current-status-div ${userDetails?.status}`}>
          <div className="offlinepayment-current-status">{userDetails?.status === "INITIATED" ? "Payment Initiated" : userDetails?.status === "SUCCESS" ? "Payment Approved" : userDetails?.status === "FAILED" ?"Payment Rejected":""}</div>
          {userDetails?.status === "FAILED" && userDetails?.comments.length > 1 && <div>{ userDetails?.comments}</div>}
          </div>}
        <div className='offline-user-name-orderid'>
          <div className='offline-user-name'>{userInfo?.name}</div>
          <div className="offline-userid">{userInfo?.order_id}</div>
          {splitPayments?.length > 0 && <>
            <hr style={{borderColor: "#707070", margin: '16px 4px', opacity: '0.1'}}/>
            {splitPayments.map((split, ind) => <div key={split.transaction_id} style={{marginBottom: '16px'}}>
              <div className='flexBet boldtxt'>
                <div>{split?.metadata?.split_number ? ("Split " + (split?.metadata?.split_number) + " payment") : split?.payment_type == "BALANCE_PAYMENT" ? "Balance Payment" : "Down Payment"}</div>
                <div>{formatAmountinINR(split.amount)}</div>
              </div>
              <div className='flexBet lighttxt'>
                <div><img src={getSplitStatusImg(split)} alt="" width={18}/> <span style={{color:split.status == "REJECTED" ? "#C91A3A" : "#707070", paddingLeft: '6px' }}>{getSplitStatusText(split)}</span></div>
                <div>{split?.metadata?.instrument_type || "Online"}</div>
              </div>
              {split?.metadata?.rejected_comment && <div className='flexBet lighttxt'>Reason: {split?.metadata?.rejected_comment}</div>}
            </div>)}
          </>}
        </div>

        {splitPayments?.length > 0 && <hr style={{borderColor: "#707070", margin: '16px 4px', opacity: '0.1'}}/>}
        {/* amount */}

        <div className="offlineAmount">
          <FloatingInput
            disabled={true}
          extraCss={"whiteBg"}
          id="Amount"
          name="Amount"
          type="text"
            labelName={paymentType == "SPLIT_PAYMENT" ? `Split ${splitPayments.reduce((a,b) => Math.max(a, b?.metadata?.split_number), 0) + 1} Amount` : "Amount"}
            inputValue={`${formatAmountinINR(offlineAmount) || formatAmountinINR(userDetails?.amount)}   ${totalPayable && `/  ${formatAmountinINR(totalPayable)}`}`}
            // onChange={(e) => { SetUserDetails(prev => { return { ...prev, amount: e } }); setOfflineAmount(e) }}
          // className={`card-number ${idInputClass}`}
            placeholder="Amount"
          // labelStyles={{ color: showErrorMsg ? "#D44C59" : "" }}
        />
        </div>

        {/* cheque cash DD RTGS NEFT IMPS*/}

        <div className="offline-type">
          <FloatingSelect
            labelName="Select payment method"
            inputValue={userDetails?.payment_method ? userDetails.payment_method : "CHEQUE"}
            onChange={() => { onPaymentMethodClick() }}
            isSelected={Boolean(userDetails?.payment_method || "CHEQUE")}
          />


          {showOfflineType && <GenericModal showClose={false} onClose={() => setOfflineType(false) }>
            <div className='offline-type-drop-down-wrapper'>
              {offlineTypes.map((el, i) =>
                <div key={i} onClick={() => { handleOfflineTypeDropDownClicked(el) }} className="individual-offline-type-div">
                  {el}
                </div>
              )}
            </div>
          </GenericModal>}

        </div>

        {/* micr number */}

        {(userDetails?.payment_method == "CHEQUE" || userDetails?.payment_method == "DEMAND_DRAFT")   && <div className="micr-number">
          <FloatingInput
            disabled={(userDetails?.status == "INITIATED" || userDetails?.status == "SUCCESS")?true:false}
            maxLength='9'
            extraCss={"whiteBg"}
            id="micr-number"
            name="micr-number"
            type="number"
            labelName={`MICR code (9 Digits)`}
            inputValue={userDetails?.micr || micrNumber }
            onChange={(e) => {setCurrentOfflineType(userDetails?.payment_method); SetUserDetails(prev => { return { ...prev, micr: e } }); setMicrNumber(e)}}
            className={`${(userDetails?.micr?.length < 9 && micrNumber?.length < 9) ? 'redBorder' : 'greenBorder'} ${userDetails?.micr?.length == 0 ? 'no-border' : ''}`}
            placeholder="MICR code"
          // labelStyles={{ color: showErrorMsg ? "#D44C59" : "" }}
          />
        </div>}

        {/* cheque number or DD nummber */}

        {userDetails?.payment_method !== "CASH" && <div className="payment-type-number">
          <FloatingInput
            disabled={(userDetails?.status == "INITIATED" || userDetails?.status == "SUCCESS") ? true : false}
            maxLength={(userDetails?.payment_method === "CHEQUE" || userDetails?.payment_method === "DEMAND_DRAFT") ? '6' : (userDetails?.payment_method === "NEFT" || userDetails?.payment_method === "RTGS") ? '22' : userDetails?.payment_method === "IMPS" ? '12': userDetails?.payment_method === "POS_MACHINE"?'10':''}
            extraCss={"whiteBg"}
            id="username"
            name="payment-type-number"
            type={userDetails?.payment_method === "CHEQUE" ? "number":"text"}
            labelName={`${(paymentMethodText || "Cheque number") + ' (' + getLength()} characters)`}
            inputValue={userDetails?.instrument_id}
            onChange={(e) => {
              if (userDetails?.payment_method === "CHEQUE") {
                SetUserDetails(prev => { return { ...prev, instrument_id: e } })
              }
              else {
                console.log(e?.target?.value,"dsfgdf",userDetails);
                // SetUserDetails(prev => {
                //     console.log("prev:=====", prev);
                //   return { ...prev, instrument_id: e?.target?.value }
                // })
              
                SetUserDetails({
                    ...userDetails,
                    instrument_id: e?.target?.value,
                });
              }
              setCurrentOfflineType(userDetails?.payment_method);
            }}
            className={`${userDetails?.instrument_id?.length == 0 ? 'no-border' : (((userDetails?.payment_method === "CHEQUE" || userDetails?.payment_method === "DEMAND_DRAFT") && userDetails?.instrument_id?.length < 6) || ((userDetails?.payment_method === "NEFT" || userDetails?.payment_method === "RTGS") && userDetails?.instrument_id?.length < 16) || (userDetails?.payment_method === "IMPS" && userDetails?.instrument_id?.length < 12)) ? 'redBorder' : 'greenBorder'}`}
            placeholder={paymentMethodText || "Cheque number"}
          // labelStyles={{ color: showErrorMsg ? "#D44C59" : "" }}
          />
        </div>}

        {/* upload doc  */}
        
        {
          
          // userDetails?.payment_method !== "CASH" &&
          <div className='offline-fileupload'>
           
          <>
            <div className="scooter-insurance-upload-document-container">
               <div style={{margin: '16px 2px 8px 0', fontWeight: 500, fontSize: '15px', color: '#333'}}>
          Additional Documents
        </div>
            {/* <div className="upload-screenshot-box">
              {!uploadedFile?.length ? (
                [1,2,3,4].map((item) => <>
                  <div>
                    <input
                      className="stretch-to-fill-container"
                      id="uploadInput"
                      type="file"
                      onChange={(evt) => onFileChange(evt, item)}
                    />
                  </div>
                  <div className="upload-plus-icon">
                    <img
                      src="https://olaelectricvideos.blob.core.windows.net/olaelectric-videos/plusIcon.svg"
                      alt=""
                      srcset=""
                    />
                  </div>
                </>)
                ) : ((userDetails?.status !== "INITIATED" && userDetails?.status !== "SUCCESS") &&

                <div className="change-uploaded-image">
                  <input
                    className="stretch-to-fill-container z-index-100"
                    id="uploadInput"
                    type="file"
                    onChange={(evt) => onFileChange(evt)}
                  />
                  <img
                    src="https://olaelectricvideos.blob.core.windows.net/olaelectric-videos/configs-static/assets/newPurchase/editIcon.png"
                    alt=""
                  />
                </div>)
              }
              <div
                style={{ display: !uploadedFile?.length ? 'none' : 'block' }}
                className="upload-preview-img"
              >
                {imgArr.map((item) => <img id={"preview-img-" + item} src="#" alt="your image" />)}
              </div>
            </div> */}
          </div>

          <div className="uploadImgWrapper" onClick={() => callOnceDataFilled()}>
              {
                imgArr?.map((list, index) => (
                  <div key={index} className="uploadImage">
                    {
                      !imgList?.["preview-img-" + list] && (
                        <img className="plus-icon" src={PlusIcon} alt="" />
                      )
                    }
                      
                      <input
                        className="input-file"
                        id={'uploadInput-2-' + index}
                        type="file"
                        data
                        onInput={(evt) => onFileChange(evt, list)}
                        onClick={(event)=> {if(!(imgList?.["preview-img-" + list])){ event.target.value = null}}}
                      />
                       <div
                        style={{ display: imgList?.["preview-img-" + list] ? 'block' : 'none' }}
                        className="upload-preview-img"
                      >
                        <img className="previewImg" id={"preview-img-" + list} src="#" alt="" />  
                      </div>
                  </div>
                ))
              }
            </div>
          </>
        </div>}

        {/* initate button */}
        <div style={{marginBottom: '16px', fontSize: '15px', color: '#333'}}>
          To upload <b>customer documents such as Aadhaar and PAN</b>, please visit the <b>Manager Orders</b> section of this Brand Champion App.
        </div>
        <div className='initiate-payment-btn-div'>
          <button onClick={() => handleInitiatePayment()} disabled={btnDisableStatus} className={`${btnDisableStatus?"disableBtnClass":""} initiate-payment-btn`}>Initiate payment</button>
        </div>
      </div>

      {showToggle && <div className="toaster">{toastMsg}</div>}

      {/* summary popup */}

      {confirmationPopup && <GenericModal showClose={false} onClose={() => setConfirmationPopup(false)} >
        <div className="confirmation-popup-wrapper">
          <div className="confirmation-header-section">
            <div className="confirmation-header-text-section">
              <div className="confirmation-header">Confirm payment
                details </div>
              <div className="confirmation-subheader">{userInfo?.name} <br /> { userInfo?.order_id}</div>
            </div>
            <div>
              <img src={Info_Yellow} alt="alert" />
            </div>
          </div>
          <div className="confirmation-popup-user-details">
            <div className="confirmation-popup-payment-type">
              <div className="confirmation-popup-payment-text">Payment method</div>
              <div className="confirmation-popup-payment-value">{userDetails?.payment_method || currentOfflineType}</div>
            </div>
            {/* <div className="confirmation-popup-payment-type">
              <div className="confirmation-popup-payment-text">Amount paid</div>
              <div className="confirmation-popup-payment-value">{userDetails?.payment_type}</div>
            </div> */}
            <div className="confirmation-popup-payment-type">
              <div className="confirmation-popup-payment-text">Amount</div>
              <div className="confirmation-popup-payment-value">{formatAmountinINR(userDetails?.amount)}</div>
            </div>
            {(currentOfflineType === "CHEQUE" || currentOfflineType === "DEMAND_DRAFT" ) && <div className="confirmation-popup-payment-type">
              <div className="confirmation-popup-payment-text">MICR code</div>
              <div className="confirmation-popup-payment-value">{userDetails?.micr || micrNumber}</div>
            </div>}
            {currentOfflineType !== "CASH" && <div className="confirmation-popup-payment-type">
              <div className="confirmation-popup-payment-text">{paymentMethodText}</div>
              <div className="confirmation-popup-payment-value">{userDetails?.instrument_id}</div>
            </div>}
          </div>
          <div className="confirmation-popup-btns-div">
            <div className="confirmation-edit-div">
              <button onClick={() => { setConfirmationPopup(false) }} className="confirmation-edit-btn" >Edit</button>
            </div>
            <div className="confirmation-confirm-div">
              <button onClick={(e) => { handleConfirmClick(e)}} className="confirmation-confirm-btn">Confirm</button>
            </div>
          </div>
        </div>
      </GenericModal>}

      {/* cancelled by cusotmer */}
      {canceledByCustomer && <GenericModal showClose={false} onClose={() => setCanceledByCustomer(false)}>
        <div className="cancelByCustomer">
          <div className='cancelByCustomerheaderdiv'>
            <div className="cancelByCustomerTitle">Payment cancelled by customer</div>
            <div>
              <img src={Info_Yellow} alt="alert" />
            </div>
          </div>
          <div className="cancelByCustomerOkayBtn">
            <button onClick={() => { setCanceledByCustomer(false) }} className="cancelByCustomerOkayBtn">Okay</button>
          </div>
            </div>
      </GenericModal>}


      {bottomSheetError !== "" && (
        <BottomSheetWithBtn
          title={'Something went wrong!!!'}
          message={bottomSheetError}
          buttonTitle="Ok"
          handleClose={() => {
           setBottomSheetError('')
          }}
          // dark={!lightTheme}
        />
      )}
    </div>
  )
}

export default OfflinePayment